import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, IconButton, Typography } from '@mui/material'
import { useTranslate } from 'react-admin'

import { AnnouncementBody, AnnouncementDate, CallToAction } from './AnnouncementParts'
import PictureSteps from './PictureSteps'
import { useLocalizedText } from '../../domain/announcements'
import { useSmallScreen } from '../../utils/theme'

const WIDE_DIALOG_SX = { '& .MuiDialog-paper.MuiDialog-paper': { maxWidth: 'none', flex: '0 1 auto' } }

const AnnouncementDetail = ({ announcement, onClose, onFollow }) => {
  const translate = useTranslate()
  const localize = useLocalizedText()
  const isSmallScreen = useSmallScreen()

  return (
    <Dialog
      open={Boolean(announcement)}
      onClose={onClose}
      fullScreen={isSmallScreen}
      maxWidth={false}
      sx={WIDE_DIALOG_SX}
      PaperProps={{
        'aria-label': announcement ? localize(announcement.title_i18n) : undefined,
        sx: {
          width: { md: 'min(1040px, calc(100vw - 64px))' },
          borderRadius: { md: 3 },
          overflow: 'hidden',
        },
      }}
    >
      {announcement && (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: { md: 480 } }}>
          <Box
            data-testid="announcement-pictures"
            sx={{
              flex: { md: '0 0 50%' },
              boxSizing: 'border-box',
              bgcolor: 'action.hover',
              display: 'grid',
              placeItems: 'center',
              p: { xs: 3, md: 4 },
            }}
          >
            <PictureSteps key={announcement.id} pictures={announcement.pictures} />
          </Box>
          <Box
            data-testid="announcement-text"
            sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', p: 3 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ flex: 1 }}>
                <AnnouncementDate announcement={announcement} />
              </Box>
              <IconButton onClick={onClose} aria-label={translate('mymove.whatsNew.close')} edge="end">
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
              {localize(announcement.title_i18n)}
            </Typography>
            <Box sx={{ flex: 1, overflowY: 'auto', maxHeight: { md: 340 } }}>
              <AnnouncementBody announcement={announcement} />
            </Box>
            {announcement.cta_url && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                <CallToAction
                  announcement={announcement}
                  onFollow={() => onFollow(announcement.id)}
                  variant="contained"
                  sx={{ whiteSpace: 'nowrap' }}
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Dialog>
  )
}

export default AnnouncementDetail
